/**
 * @file Micro-helpers DOM (creation d'elements typee, mise a jour de texte sans re-rendu, attributs data-*) : pas de framework, pas d'innerHTML.
 */

type Attrs = Record<string, string | number | boolean | undefined | ((ev: Event) => void)>;
type Child = Node | string | null | undefined | false;

/** h('button', { class: 'btn', onclick: fn, 'data-tutorial': 'x' }, 'Texte') */
export const h = <K extends keyof HTMLElementTagNameMap>(tag: K, attrs: Attrs = {}, ...children: Child[]): HTMLElementTagNameMap[K] => {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === undefined || v === false) continue;
    if (typeof v === 'function' && k.startsWith('on')) el.addEventListener(k.slice(2), v as EventListener);
    else if (k === 'class') el.className = String(v);
    else el.setAttribute(k, v === true ? '' : String(v));
  }
  for (const c of children) if (c !== null && c !== undefined && c !== false) el.append(typeof c === 'string' ? document.createTextNode(c) : c);
  return el;
};

/** Met a jour textContent seulement si la valeur change (evite les relayouts a chaque frame). */
export const setText = (el: Element, value: string): void => {
  if (el.textContent !== value) el.textContent = value;
};

export const toggleClass = (el: Element, cls: string, on: boolean): void => {
  if (el.classList.contains(cls) !== on) el.classList.toggle(cls, on);
};

export const clear = (el: Element): void => {
  while (el.firstChild) el.removeChild(el.firstChild);
};

/** Style CSS custom property (ex. --progress) si changee. */
export const setVar = (el: HTMLElement, name: string, value: string): void => {
  if (el.style.getPropertyValue(name) !== value) el.style.setProperty(name, value);
};
